<template>
    <div class="container-fluid" v-if="tracker && posicao">

        <header-admin :rastreador="tracker" :posicao="posicao" :veiculo="veiculo"></header-admin>

        <vk-tabs :keep-alive="true">

            <vk-tabs-item title="INICIAL">
                <positions-maps :posicao="posicao"/>
            </vk-tabs-item>

            <vk-tabs-item title="COMANDOS" v-if="rastreador">

                <div class="col-sm-3">
                    <enviar-saidas :enable_output2="false" :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset-gps :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                    <solicitar-posicao :id_rastreador="rastreador.id_rastreador" />
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>

            <vk-tabs-item title="PROBLEMAS" v-if="veiculo">
                <problemas  @reload="loadVeiculo($event)" :veiculo="veiculo"></problemas>
            </vk-tabs-item>

            <vk-tabs-item title="VEÍCULO" v-if="veiculo">
                <dados-do-veiculo-admin :veiculo="veiculo"/>
            </vk-tabs-item>

            <vk-tabs-item title="CLIENTE" v-if="cliente">
                <dados-do-cliente-admin :cliente="cliente"/>
            </vk-tabs-item>

            <vk-tabs-item title="RELATÓRIOS" v-if="veiculo">
                <dados-relatorios-admin :veiculo="veiculo"/>
            </vk-tabs-item>

            <vk-tabs-item title="CONFIGURAÇÃO" v-if="config">
                <vk-tabs-vertical>

                    <vk-tabs-item title="COMANDO LIVRE" >
                        <comando-livre :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="TEMPOS" >
                        <tempos :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="SLEEP & WAKE" >
                        <sleep :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="HEARTBEAT" >
                        <hbt :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="APN">
                        <apn :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="IP">
                        <ip :config="config"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="HODOMETRO">
                        <ajustar-hodometro :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                    <vk-tabs-item title="HORIMETRO">
                        <ajustar-horimetro :id_rastreador="rastreador.id_rastreador"/>
                    </vk-tabs-item>

                </vk-tabs-vertical>

            </vk-tabs-item>

        </vk-tabs>

    </div>
    <div class="container-fluid" v-else>
        <center>
            <h1>Aguardando dados e primeira transmissão</h1>
        </center>
        <vk-tabs :keep-alive="true">

            <vk-tabs-item title="COMANDOS" v-if="rastreador">

                <div class="col-sm-3">
                    <enviar-saidas :enable_output2="false" :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset :id_rastreador="rastreador.id_rastreador"/><br/>
                    <reset-gps :id_rastreador="rastreador.id_rastreador"/><br/>
                    <solicitar-configuracao :id_rastreador="rastreador.id_rastreador"/>
                    <solicitar-posicao :id_rastreador="rastreador.id_rastreador" />
                </div>

                <div class="col-sm-9">
                    <table-comandos :id_rastreador="rastreador.id_rastreador"/>
                </div>

            </vk-tabs-item>
        </vk-tabs>
    </div>
</template>
<script>
    import {Rastreador, Concox} from '../../class/index';
    import SolicitarConfiguracao from '../../components/buttons/SolicitarConfiguracao.vue';
    import Tempos from './partials/x3tech/Tempos';
    import Apn from './partials/x3tech/Apn';
    import Ip from './partials/x3tech/Ip';
    import Filtro from './partials/x3tech/Filtro';
    import ComandoLivre from './partials/generico/ComandoLivre.vue';
    import HeaderAdmin from './HeaderAdmin';
    import Relatorios from '../../components/veiculo/Relatorios';
    import RelatorioPeriodo from '../relatorios/RelatorioPeriodo';
    import EnviarSaidas from '../../components/buttons/EnviarSaidas';
    import RelatorioAlertas from "../relatorios/RelatorioAlertas";
    import Problemas from "../veiculo/Problemas";
    import TableComandos from "../tables/TableComandos";
    import Reset from "../buttons/Reset";
    import AjustarHodometro from './partials/AjustarHodometro.vue';
    import {veiculosAdminMixins} from './partials/veiculo-admin-mixins';
    import ResetGps from "../buttons/ResetGps";
    import SolicitarPosicao from "../buttons/SolicitarPosicao";
    import Sleep from "./partials/x3tech/Sleep";
    import Hbt from "./partials/x3tech/Hbt";
    import AjustarHorimetro from "./partials/AjustarHorimetro.vue";
    import PositionsMaps from './partials/PositionsMaps.vue';
    import DadosDoClienteAdmin from './partials/DadosDoClienteAdmin.vue';
    import DadosDoVeiculoAdmin from './partials/DadosDoVeiculoAdmin.vue';
    import DadosRelatoriosAdmin from './partials/DadosRelatoriosAdmin.vue';

    export default {
        components: {
            DadosRelatoriosAdmin,
            DadosDoVeiculoAdmin,
            DadosDoClienteAdmin,
            PositionsMaps,
            AjustarHorimetro,
            Hbt,
            Sleep,
            SolicitarPosicao,
            ResetGps,
            Problemas,
            ComandoLivre,
            EnviarSaidas, AjustarHodometro,
            HeaderAdmin,
            TableComandos, Reset,

            SolicitarConfiguracao, Tempos, Apn, Ip, Filtro
        },

        mixins: [
            veiculosAdminMixins
        ],

        data(){
            return {
                config: null,
            }
        },

        async beforeMount(){
            this.config = await Concox.byPK(this.rastreador.id_rastreador);
        },

    }
</script>
